import React, { useEffect, useState } from 'react';
import '../../styles/Admin/accountForms.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { GrUserAdmin } from 'react-icons/gr';
import { displaySnackbar } from '../../utilities';
import { v4 as uuid } from 'uuid';
import { BASE_URL } from '../../settings';

export default function Admin_AddJobPost({ fetchJobPosts }) {
    const [companyName, setCompanyName] = useState('');
    const [positionName, setPositionName] = useState('');
    const [count, setCount] = useState();
    const [email, setEmail] = useState();
    const [redirectUrl, setRedirectUrl] = useState('');
    const [details, setDetails] = useState('');
    const [qualifications, setQualifications] = useState([]);
    const [newQualification, setNewQualification] = useState('');
    const [isAddingMore, setIsAddingMore] = useState(false);
    const [dueDate, setDueDate] = useState(new Date());
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // 👇️ handler for creating a new job ost.
    const createJobPost = () => {
        setError(null);
        setMessage(null);
        setShowLoading(true);

        if (companyName && companyName?.length > 0 && isNaN(companyName) && companyName?.trim()) {
            if (
                positionName &&
                positionName?.length > 0 &&
                isNaN(positionName) &&
                positionName?.trim()
            ) {
                if (count) {
                    if (!isNaN(count)) {
                        if (details && details?.length > 0 && isNaN(details) && details?.trim()) {
                            fetch(`${BASE_URL}/jobs/`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    email,
                                    companyName,
                                    positionName,
                                    count,
                                    redirectUrl,
                                    details,
                                    qualifications,
                                    dueDate,
                                }),
                            })
                                .then(async (result) => {
                                    setShowLoading(false);
                                    setError(null);
                                    let response = await result?.json();
                                    if (response?.msg === null) {
                                        setError(response?.errorMsg);
                                        displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                                    } else {
                                        console.log(response);
                                        setMessage(response?.msg);
                                        displaySnackbar(response?.msg, false, 'Ok', () => {});
                                        setTimeout(() => {
                                            fetchJobPosts();
                                            navigate('/admin.console/jobposts');
                                        }, 1000);
                                    }
                                })
                                .catch((error) => {
                                    if (error?.message == 'Failed to fetch') {
                                        setError('Could not reach the servers');
                                        displaySnackbar(
                                            'Could not reach the servers',
                                            true,
                                            'Ok',
                                            () => {}
                                        );
                                    } else {
                                        setError('Some error occurred!');
                                        displaySnackbar(
                                            'Some error occured!',
                                            true,
                                            'Ok',
                                            () => {}
                                        );
                                        console.log('the error:', error);
                                    }
                                    setShowLoading(false);
                                    setMessage(null);
                                });
                        } else {
                            setShowLoading(false);
                            setError('provide job post details');
                            setMessage(null);
                        }
                    } else {
                        setShowLoading(false);
                        setError('invalid value for required employees!');
                        setMessage(null);
                    }
                } else {
                    setShowLoading(false);
                    setError('Provide required employees!');
                    setMessage(null);
                }
            } else {
                setShowLoading(false);
                setError('Provide positionName!');
                setMessage(null);
            }
        } else {
            setShowLoading(false);
            setError('Provide companyName!');
            setMessage(null);
        }
    };

    // 👇️ handler to add a qualification
    const addQualification = () => {
        if (
            newQualification &&
            newQualification?.length > 0 &&
            newQualification?.trim() &&
            isNaN(newQualification)
        ) {
            setQualifications([
                ...qualifications,
                {
                    id: uuid(),
                    name: newQualification,
                },
            ]);
            setNewQualification('');
            setIsAddingMore(false);
        }
    };

    // 👇️ handler to remove a qualification
    const removeQualification = (item) => {
        if (item) {
            let filteredQualifications = qualifications.filter(
                (the_item) => the_item?.id != item?.id
            );
            setQualifications(filteredQualifications);
        }
    };

    return (
        <div className='admin-login-container'>
            <div className='login-container'>
                <div className='form-header-container'>
                    <span
                        style={{
                            fontSize: '2rem',
                        }}
                    >
                        🏢
                    </span>
                    <h1 className='form-header'>New Job Post</h1>
                </div>

                {error && <span className='error'>{error}</span>}
                {message && <span className='message'>{message}</span>}

                <div className='form-inputs'>
                    <input
                        type='text'
                        name='email'
                        placeholder='company email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <input
                        type='text'
                        name='companyName'
                        placeholder='company name'
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                    />

                    <input
                        type='text'
                        name='positionName'
                        placeholder='required position'
                        value={positionName}
                        onChange={(e) => setPositionName(e.target.value)}
                    />

                    <input
                        type='number'
                        name='count'
                        placeholder='required employees'
                        value={count}
                        onChange={(e) => setCount(e.target.value)}
                    />

                    <input
                        type='url'
                        name='redirectUrl'
                        placeholder='redirect url e.g https://www.econnet.co.zw'
                        value={redirectUrl}
                        onChange={(e) => setRedirectUrl(e.target.value)}
                    />

                    <label htmlFor='dueDate'>Due date</label>
                    <input
                        type='date'
                        name='dueDate'
                        id='dueDate'
                        placeholder='due date'
                        value={dueDate}
                        title='the date that this offer closes.'
                        onChange={(e) => setDueDate(e.target.value)}
                    />

                    <label htmlFor='qualifications'>Qualifications</label>
                    {qualifications.length > 0 ? (
                        <ul id='qualifications'>
                            {qualifications.map((item, index) => (
                                <div className='qualification-item-container'>
                                    <li key={`qualification-#${index}-#${item?.id}`}>
                                        {item?.name || 'qualification'}
                                    </li>
                                    <span onClick={() => removeQualification(item)}>x</span>
                                </div>
                            ))}

                            {isAddingMore && (
                                <div className='adding-more-qualification-container'>
                                    <input
                                        type='text'
                                        name='new qualification'
                                        id='new-qualification'
                                        placeholder='new qualification'
                                        value={newQualification}
                                        onChange={(e) => setNewQualification(e.target.value)}
                                    />
                                    <button onClick={addQualification}>+</button>
                                    <button
                                        style={{
                                            color: 'red',
                                            backgroundColor: 'transparent',
                                            border: '.1rem solid darkblue',
                                            borderRadius: '.3rem',
                                        }}
                                        onClick={() => setIsAddingMore(false)}
                                    >
                                        x
                                    </button>
                                </div>
                            )}
                            <span
                                className='empty-qualifications-text'
                                onClick={() => setIsAddingMore(true)}
                            >
                                Add more...
                            </span>
                        </ul>
                    ) : (
                        <>
                            {isAddingMore && (
                                <div className='adding-more-qualification-container'>
                                    <input
                                        type='text'
                                        name='new qualification'
                                        id='new-qualification'
                                        placeholder='new qualification'
                                        value={newQualification}
                                        onChange={(e) => setNewQualification(e.target.value)}
                                    />
                                    <button onClick={addQualification}>+</button>
                                    <button
                                        style={{
                                            color: 'red',
                                            backgroundColor: 'transparent',
                                            border: '.1rem solid darkblue',
                                            borderRadius: '.3rem',
                                        }}
                                        onClick={() => setIsAddingMore(false)}
                                    >
                                        x
                                    </button>
                                </div>
                            )}
                            <span
                                className='empty-qualifications-text'
                                onClick={() => setIsAddingMore(true)}
                            >
                                Add some...
                            </span>
                        </>
                    )}

                    {/* <select name='positionName' onChange={(e) => setPositionName(e?.target?.value)}>
                        <option selected disabled>
                            positionName
                        </option>
                        <option value={'high'}>high</option>
                        <option value={'low'}>low</option>
                    </select> */}
                    <textarea
                        type='text'
                        name='details'
                        placeholder='job post details'
                        rows={10}
                        value={details}
                        onChange={(e) => setDetails(e.target.value)}
                    />
                </div>

                <button
                    className='action-btn'
                    onClick={createJobPost}
                    disabled={
                        showLoading ||
                        companyName?.length <= 0 ||
                        positionName?.length <= 0 ||
                        count?.length <= 0 ||
                        count?.length <= 0
                    }
                    style={{
                        backgroundColor:
                            showLoading || !companyName || !positionName || !count
                                ? '#aaa'
                                : 'darkblue',
                        color:
                            showLoading || !companyName || !positionName || !count
                                ? '#333'
                                : '#eee',
                    }}
                >
                    Create
                </button>

                <span className='link' onClick={() => navigate('/admin.console/jobposts')}>
                    👈️ Go back to job posts
                </span>
            </div>
        </div>
    );
}
